var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MemberProfileEdit.jinja');
require('./MemberProfileEdit.less');

var MemberProfileEditInfo = require('front/components/MemberProfileEdit/MemberProfileEditInfo');
var MemberProfileEditPrivate = require('front/components/MemberProfileEdit/MemberProfileEditPrivate');
var MemberProfileEditPassword = require('front/components/MemberProfileEdit/MemberProfileEditPassword');
var MemberProfileEditPasswordForgot = require('front/components/MemberProfileEdit/MemberProfileEditPasswordForgot');
var MemberProfileEditBio = require('front/components/MemberProfileEdit/MemberProfileEditBio');
var MemberProfileEditDomicile = require('front/components/MemberProfileEdit/MemberProfileEditDomicile');
var MemberProfileEditSkills = require('front/components/MemberProfileEdit/MemberProfileEditSkills');
var MemberProfileEditExperience = require('front/components/MemberProfileEdit/MemberProfileEditExperience');
var MemberProfileEditRecognition = require('front/components/MemberProfileEdit/MemberProfileEditRecognition');
var MemberProfileEditLocation = require('front/components/MemberProfileEdit/MemberProfileEditLocation');
var MemberProfileEditCredits = require('front/components/MemberProfileEdit/MemberProfileEditCredits');
var MemberProfileEditCreditsAdd = require('front/components/MemberProfileEdit/MemberProfileEditCreditsAdd');
var MemberProfileEditPortfolio = require('front/components/MemberProfileEdit/MemberProfileEditPortfolio');

module.exports = Base.extend({

    template: template,

    events: {
        'touchstart .MemberProfileEdit-popup': 'onTouchStart',
        'touchmove .MemberProfileEdit-popup': 'onTouchMove'
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'closeEdit', 'onResize');

        window.app.vent.trigger('MemberProfileEdit-openPopup');

        if (this.options.block == 'info') {
            this.MemberProfileEdit = new MemberProfileEditInfo({
                el: this.$('.MemberProfileEditInfo')[0],
                memberId: this.options.memberId
            });
        }

        if (this.options.block == 'settings') {
            this.MemberProfileEdit = new MemberProfileEditPrivate({
                el: this.$('.MemberProfileEditPrivate')[0],
                visibility: this.options.visibility,
                memberId: this.options.memberId
            });
        }

        if (this.options.block == 'password') {
            this.MemberProfileEdit = new MemberProfileEditPassword({
                el: this.$('.MemberProfileEditPassword')[0],
                memberId: this.options.memberId
            });
        }

        if (this.options.block == 'passwordForgot') {
            this.MemberProfileEditForgot = new MemberProfileEditPasswordForgot({
                el: this.$('.MemberProfileEditPasswordForgot')[0],
                memberId: this.options.memberId
            });
        }

        if (this.options.block == 'bio') {
            this.MemberProfileEdit = new MemberProfileEditBio({
                el: this.$('.MemberProfileEditBio')[0],
                memberId: this.options.memberId
            });
        }

        if (this.options.block == 'domicile') {
            this.MemberProfileEdit = new MemberProfileEditDomicile({
                el: this.$('.MemberProfileEditDomicile')[0],
                memberId: this.options.memberId
            });
        }

        if (this.options.block == 'skills') {
            this.MemberProfileEdit = new MemberProfileEditSkills({
                el: this.$('.MemberProfileEditSkills')[0],
                memberId: this.options.memberId
            });
        }

        if (this.options.block == 'experience') {
            this.MemberProfileEdit = new MemberProfileEditExperience({
                el: this.$('.MemberProfileEditExperience')[0],
                memberId: this.options.memberId
            });
        }

        if (this.options.block == 'recognition') {
            this.MemberProfileEdit = new MemberProfileEditRecognition({
                el: this.$('.MemberProfileEditRecognition')[0],
                memberId: this.options.memberId
            });
        }

        if (this.options.block == 'location') {
            this.MemberProfileEdit = new MemberProfileEditLocation({
                el: this.$('.MemberProfileEditLocation')[0],
                memberId: this.options.memberId
            });
        }

        if (this.options.block == 'credits') {
            this.MemberProfileEdit = new MemberProfileEditCredits({
                el: this.$('.MemberProfileEditCredits')[0],
                memberId: this.options.memberId
            });
        }

        if (this.options.block == 'creditsAdd') {
            this.MemberProfileEditForgot = new MemberProfileEditCreditsAdd({
                el: this.$('.MemberProfileEditCreditsAdd')[0],
                memberId: this.options.memberId
            });
        }

        if (this.options.block == 'creditsEdit') {
            this.MemberProfileEditForgot = new MemberProfileEditCreditsAdd({
                el: this.$('.MemberProfileEditCreditsAdd')[0],
                item: this.options.item,
                memberId: this.options.memberId
            });
        }

        if (this.options.block == 'portfolio') {
            this.MemberProfileEdit = new MemberProfileEditPortfolio({
                el: this.$('.MemberProfileEditPortfolio')[0],
                memberId: this.options.memberId
            });
        }

        if (!$('.MemberProfile').attr('onkeydown')) {
            $('.MemberProfile').attr('onkeydown', true);
            $(window).on('keydown', this.closeEdit);

            if (!app.settings.isPhone) {
                this.savedScroll = $(window).scrollTop();

                $('.BasePopup')
                    .addClass('FixedOnPopup')
                    .outerHeight();

                $('.BasePopup').css('top', -this.savedScroll + 'px');

                $('.MemberProfile').scrollTop(0);
                $('.MemberProfile').focus(); //for pgdn pgup shortcuts

                $(window).on('resize', this.onResize);
            }
        }
        this.onResize();

        Base.prototype.initialize.call(this, options);
    },


    viewsRegistration: function () {
        Base.prototype.viewsRegistration.call(this);

    },


    onTouchStart: function (e) {
        this.popupScrollY = e.originalEvent.touches.item(0).clientY;
    },


    onTouchMove: function (e) {
        if (!app.settings.isPhone) return;

        var $scrollbox = this.$('.MemberProfileEdit-scrollbox');

        //private edit popup
        if (!$scrollbox.length) {
            var $scrollbox = this.$('.MemberProfileEdit-popup');
        }

        var $target = $(e.target);
        var delta = this.popupScrollY - e.originalEvent.touches.item(0).clientY;

        if (!$target.closest($scrollbox).length) {
            e.preventDefault();
        }

        if ((delta < 0 && $scrollbox.scrollTop() <= 0) ||
            (delta > 0 && $scrollbox.scrollTop() + $scrollbox.outerHeight() >= $scrollbox[0].scrollHeight - 1)) { //-1 due to scaling float sizes
            e.preventDefault();
        }

        this.popupScrollY = e.originalEvent.touches.item(0).clientY;
    },


    onResize: function () {
        if (app.settings.isPhone) return;

        var hw = $(window).innerHeight();
        var hPopup = $('.MemberProfileEdit-popup').innerHeight();
        var margTop = Math.max((hw - hPopup) / 2, 0);

        if ((hw - hPopup) <= 0) {
            $('.MemberProfileEdit-popup').css({
                'top': 0,
                'margin-bottom': 0
            });
        } else {
            $('.MemberProfileEdit-popup').css('top', margTop);
        }
    },

    closeEdit: function (e) {
        var component = false;

        if (e.keyCode == 27) { //esc
            $('.MemberProfileEdit').each(function (ind, section) {
                component = $(this).data('component');
            });

            window.app.vent.trigger('MemberProfileEdit--close', component);
        }
    },

    deactivate: function (params) {
        if (this.options.block == 'passwordForgot' || this.options.block == 'creditsEdit' || this.options.block == 'creditsAdd') {
            this.MemberProfileEditForgot.deactivate();
            delete this.MemberProfileEditForgot;
        } else {
            this.MemberProfileEdit.deactivate();
            delete this.MemberProfileEdit;
        }


        if (this.options.block != 'passwordForgot' && this.options.block != 'creditsEdit'/* && this.options.block != 'creditsAdd'*/) {
            $(window).off('keydown', this.closeEdit);
            $('.MemberProfile').removeAttr('onkeydown');
            window.app.vent.trigger('MemberProfileEdit-closePopup');

            if (!app.settings.isPhone) {
                $('.BasePopup')
                    .removeClass('FixedOnPopup')
                    .outerHeight();

                $('.BasePopup').css('top', '');

                $(window).scrollTop(this.savedScroll);
                $(window).off('resize', this.onResize);
            }
        }

        return Base.prototype.deactivate.call(this, params);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileEdit/MemberProfileEdit.js
// module id = 207
// module chunks = 0